module.exports = __webpack_public_path__ + "img/call.dcdb0bee.svg";